import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import { getAsset } from '../../../../../util/assets';

const propTypes = {
  label: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.string.isRequired,
  url: PropTypes.string,
  onClick: PropTypes.func,
};

const EventButton = ({ label, icon, url, onClick, subtitle }) => {
  return (
    <Button
      btnStyle="reset"
      to={url}
      onClick={onClick}
      className="new-content-event-block"
    >
      <div
        className="new-content-event-block-content"
        style={{ backgroundImage: `url("${getAsset(icon)}")` }}
      >
        <div className="new-content-event-block-content-copy">
          <span className="text-primary">{label}</span>
          {subtitle && <span className="text-primary text-xs">{subtitle}</span>}
        </div>
      </div>
    </Button>
  );
};

EventButton.propTypes = propTypes;

export default EventButton;
